// @flow
import * as React from 'react';

import usePersonnel from 'common/hooks/usePersonnel';
import { type Operations } from './types';

const usePermissionMatch = (operations: Operations): boolean => {
    const personnel = usePersonnel();

    const isMatching = React.useMemo(() => {
        return personnel.hasPermission(operations);
    }, [personnel, operations]);

    return isMatching;
};

export default usePermissionMatch;
